<form [formGroup]="form" (ngSubmit)="addProtocol()">
    <div class="card-content">
        <div>
            <div class="full-width">
                <div class="card-inline">
                    <mat-form-field class="margin-right-small">
                        <input type="text" #newProtocol matInput placeholder="Protocolo" formControlName="NewProtocol">
                    </mat-form-field>
                    <button *ngIf="!loading" type="submit" mat-icon-button mat-mini-fab>
            <mat-icon>add</mat-icon>
          </button>
                    <div style="font-weight: bold; color: green" *ngIf="protocolAdded()">{{protocolAdded()}}</div>
                    <div style="font-weight: bold; color: red" *ngIf="protocolNoAdded()">{{protocolNoAdded()}}</div>
                </div>
                <mat-divider></mat-divider>
                <mat-spinner *ngIf="loading"></mat-spinner>
                <table mat-table class="search-table margin-botton-medium" *ngIf="!loading" [dataSource]="dataSource">
                    <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayColumns"></tr>
                    <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayColumns;"></tr>

                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null" [checked]="selection.isSelected(element)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Protocol">
                        <th mat-header-cell class="table-header" *matHeaderCellDef> Protocolo </th>
                        <td class="search-table-cell" mat-cell *matCellDef="let element">
                            {{element.Protocol}}
                        </td>
                    </ng-container>
                </table>
                <h4 *ngIf="noFindProtocols.length > 0">Protocolos no encontrados</h4>
                <mat-divider *ngIf="noFindProtocols.length > 0"></mat-divider>
                <table *ngIf="noFindProtocols.length > 0">
                    <tr *ngFor="let protocol of noFindProtocols">
                        <td style="font-weight: bold; color: red">{{protocol}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</form>